// Shared helpers + presentation utilities used across the Email
// components. Pulled out of the old monolithic EmailPage.jsx in
// iter-110 so each dialog / view can be a focused module.

export function fmtSize(bytes) {
    if (!bytes && bytes !== 0) return "—";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

/**
 * Outlook-style relative date:
 *   - Today      → "9:42 AM"
 *   - Yesterday  → "Yesterday 9:42 AM"
 *   - This week  → "Mon 9:42 AM"
 *   - This year  → "Mar 4, 9:42 AM"
 *   - Older      → "3/4/2024 9:42 AM"
 */
export function fmtRelDate(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        const now = new Date();
        const time = d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
        const sameDay = d.toDateString() === now.toDateString();
        if (sameDay) return time;
        const y = new Date(now);
        y.setDate(now.getDate() - 1);
        if (d.toDateString() === y.toDateString()) return `Yesterday ${time}`;
        const dayMs = 24 * 60 * 60 * 1000;
        if (now - d < 7 * dayMs) {
            const wk = d.toLocaleDateString([], { weekday: "short" });
            return `${wk} ${time}`;
        }
        if (d.getFullYear() === now.getFullYear()) {
            const md = d.toLocaleDateString([], { month: "short", day: "numeric" });
            return `${md}, ${time}`;
        }
        const md = d.toLocaleDateString([], { year: "numeric", month: "numeric", day: "numeric" });
        return `${md} ${time}`;
    } catch {
        return "";
    }
}

export function quoteOriginal(msg, header = "Original message") {
    const dateStr = msg.date ? new Date(msg.date).toLocaleString() : "";
    const lines = (msg.body_text || "").split("\n").map((l) => `> ${l}`).join("\n");
    return `\n\n\n--- ${header} ---\nFrom: ${msg.from_name ? `${msg.from_name} ` : ""}<${msg.from_addr}>\nDate: ${dateStr}\nSubject: ${msg.subject || ""}\n\n${lines}`;
}

// Shared Tailwind classes for the Advanced IMAP/SMTP override inputs
// in AddAccountDialog. Kept as a constant so the same look is used
// for every advanced field.
export const ADV_INPUT_CLS = "bg-[#05091A] border border-[#2A3655] rounded-sm px-2 py-1.5 text-white placeholder:text-slate-600 focus:outline-none focus:border-[#00A3FF]";
